<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'المقابلات الشخصية'" :to="{name: 'interviews'}"> المقابلات الشخصية</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">


                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                        إدارة المقابلات الشخصية
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <!-- <li class="list-inline-item"><create-button  v-if="hasPermissions('interviews_create')" :routeName="'interviews.create'"></create-button></li> -->
                                        <li class="list-inline-item">

<button class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1" v-if="searchingMode == 0" @click="searchingMode = 1"><span>فلاتر البحث</span></button>
                                <button class="btn btn-danger search-btn-wg mb-2 my-2" v-if="searchingMode == 1" @click="searchingMode = 0">إغلاق X</button>
                                </li>

                                      </ul>

                                      </div>
                                </div>

                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-4">
                                          <label for="">الاسم</label>
                                          <input type="text" v-model="data.searching.name" class="form-control" placeholder="الاسم">
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">رقم جوال ولى الامر</label>
                                          <input type="text" v-model="data.searching.parent_mobile" class="form-control" placeholder="رقم جوال ولي الامر">
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">حالة الطالب</label>
                                          <select class="form-control" v-model="data.searching.status">
                                            <option value="مقبول">مقبول</option>
                                            <option value="غير مقبول">غير مقبول</option>
                                          </select>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">المرحلة الدراسية</label>
                                            <treeselect :options="stages" v-model="data.searching.stage_id" @select="getGroups" :multiple="false" />
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">الصف الدراسى</label>
                                          <treeselect :options="groups" v-model="data.searching.group_id" :multiple="false" />
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">من تاريخ المقابلة</label>
                                          <date-picker v-model="data.searching.interview_date_from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">إلى تاريخ المقابلة</label>
                                          <date-picker v-model="data.searching.interview_date_to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-4 mt-2">
                            <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">
                                  <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div class="col-md-12">
                                      <button @click.prevent="printTable" v-if="data.data.length" class="btn btn-success mt-2 mb-2">
                                        <i class="fa fa-print"></i> طباعة
                                      </button>
                                    </div>
                                    <div class="col-md-12" id="print-table">
                                        <table class="table table-bordered mb-4">
                                          <thead>
                                              <tr>
                                                <th>
                                                    <a href="#" @click.prevent="resortData();">
                                                      <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                      <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                    </a>
                                                  </th>
                                                  <th @click="resortData();">الاسم</th>
                                                  <th @click="resortData();">الصف الدراسى</th>
                                                  <th @click="resortData();">المرحلة الدراسية</th>
                                                  <th @click="resortData();">رقم جوال ولى الامر</th>
                                                  <th class="align-center">#</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr v-for="(item, index) in data.data" :key="index">
                                                  <td>{{index+1}}</td>
                                                  <td>{{item.name}}</td>
                                                  <td>{{item.group ? item.group.name : '---'}}</td>
                                                  <td>{{item.stage ? item.stage.name : '---'}}</td>
                                                  <td>{{item.parent_mobile}}</td>
                                                  <td class="text-center">

                                                      <div class="dropdown custom-dropdown">
                                                          <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                              <i class="flaticon-dot-three fs-17"></i>
                                                          </a>

                                                          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                              <a href="#" class="dropdown-item" @click.prevent="print(item)">طباعة</a>
                                                              <edit-button v-if="hasPermissions('interviews_edit')" :routing="{name: 'interviews.edit', params: {id: item.id}}"></edit-button>
                                                              <router-link :title="'ترحيل'"  v-if="item.status == 'مقبول' && item.students_count == 0 && hasPermissions('students_create')"  class="dropdown-item" href="javascript:void(0);" :to="{name: 'students.create', query: {interview: item.id}}">ترحيل الطالب</router-link>
                                                              <a :title="'مرحل'"  v-if="item.status == 'مقبول' && item.students_count != 0 && hasPermissions('students_create')"  class="dropdown-item" href="javascript:void(0);" @click.prevent="sweetAlert('تم ترحيل البيانات من قبل', 'warning')" to="#" readonly>مرحل بالفعل</a>

                                                              <delete-button v-if="hasPermissions('interviews_delete')" :deleteUrl="'/interviews/' + item.id" :data="item" @deleteData="deleteData"></delete-button>
                                                          </div>
                                                      </div>

                                                  </td>
                                              </tr>
                                          </tbody>
                                          <tfoot>
                                              <tr>
                                                <th>
                                                    <a href="#" @click.prevent="resortData();">
                                                      <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                      <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                    </a>
                                                  </th>
                                                  <th @click="resortData();">الاسم</th>
                                                  <th @click="resortData();">الصف الدراسى</th>
                                                  <th @click="resortData();">المرحلة الدراسية</th>
                                                  <th @click="resortData();">رقم جوال ولى الامر</th>
                                                  <th class="align-center">#</th>
                                              </tr>
                                          </tfoot>

                                      </table>
                                    </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
              <div class="row" style="display: none;" id="printMe">
                <div class="col-md-12">
                   <table class="table table-bordered">
                    <tbody>
                      <tr class="text-center">
                        <th colspan="4">
                          استمارة مقابلة شخصية<br>
                        </th>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td colspan="2">الاسم</td>
                        <td colspan="2">{{printData.name}}</td>
                      </tr>
                      <tr>
                        <td>الصف الدراسى</td>
                        <td>{{printData.group ? printData.group.name : '---'}}</td>
                        <td>المرحلة الدراسية</td>
                        <td>{{printData.stage ? printData.stage.name : '---'}}</td>
                      </tr>
                      <tr>
                        <td>تاريخ الميلاد</td>
                        <td>{{printData.birth_date}}</td>
                        <td>العمر</td>
                        <td>{{printData.age}}</td>
                      </tr>
                      <tr>
                        <td>رقم تلفون المنزل</td>
                        <td>{{printData.phone}}</td>
                        <td>رقم جوال ولى الامر</td>
                        <td>{{printData.parent_mobile}}</td>
                      </tr>
                      <tr v-if="printData.mobile">
                        <td colspan="2">رقم جوال الطالب</td>
                        <td colspan="2">{{printData.mobile}}</td>
                      </tr>
                      <tr>
                        <td colspan="2">هل تم الالتحاق بحلقات التحفيظ قبل ذلك فى مسجد الكوثر؟</td>
                        <td colspan="2">
                          {{ printData.quaran_join }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">هل تم الالتحاق بحلقات التحفيظ فى أى مسجد قبل هذه المرة؟ ... اين ؟</td>
                        <td colspan="2">
                          {{ printData.join_other + ' ' }} <span v-if="printData.join_other == 'نعم'">{{', ' + printData.join_other_txt}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">هل تم اختبار أى فروع من فروع الاختبارات فى الجمعية قبل ذلك ... أى فرع ؟</td>
                        <td colspan="2">
                          {{ printData.choose_branch + ' ' }} <span v-if="printData.choose_branch == 'نعم'">{{', ' + printData.choose_branch_txt}}</span>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="2">كم مقدار الحفظ الذى تستطيع حفظه يومياً ؟</td>
                        <td colspan="2">
                          {{ printData.save_daily_qty}}
                        </td>
                      </tr>

                      <tr>
                        <td colspan="2">ما هى الطريقة التى اعتدت عليها فى الحفظ ؟</td>
                        <td colspan="2">
                          {{ printData.sav_way}}
                        </td>
                      </tr>

                      <tr class="text-center">
                        <td colspan="4">
                          خاص بإدارة الحلقات
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">الاختبار</td>
                        <td colspan="2">
                          {{ printData.test}}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">السورة</td>
                        <td colspan="2">
                          {{ printData.sora}}
                        </td>
                      </tr>
                      <tr>
                        <td>من آية</td>
                        <td>{{printData.from_aya}}</td>
                        <td>إلى آية</td>
                        <td>{{printData.to_aya}}</td>
                      </tr>
                      <tr>
                        <td>تقدير التجويد</td>
                        <td>{{printData.tagwid_avg}}</td>
                        <td>تقدير الحفظ</td>
                        <td>{{printData.save_avg}}</td>
                      </tr>
                      <tr>
                        <td>الاداء</td>
                        <td>{{printData.pref_avg}}</td>
                        <td>الصوت</td>
                        <td>{{printData.sound_avg}}</td>
                      </tr>
                      <tr>
                        <td>اسم المختبر</td>
                        <td>{{printData.test_name}}</td>
                        <td>التوصية</td>
                        <td>{{printData.twsaya}}</td>
                      </tr>
                      <tr class="text-center">
                        <td colspan="4">رأى اللجان وحالة الطالب</td>
                      </tr>
                      <tr>
                        <td>رأى لجنة الحفظ والمراجعة</td>
                        <td>{{printData.opinion_of_teachers}}</td>
                        <td>رأى لجنة السلوك والانضباط</td>
                        <td>{{printData.opinion_of_slok}}</td>
                      </tr>
                      <tr>
                        <td colspan="2">ملحظات السلوك</td>
                        <td colspan="2">{{printData.notes_of_slok}}</td>
                      </tr>
                      <tr>
                        <td colspan="2">حالة الطالب</td>
                        <td colspan="2">{{printData.status}}</td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                <div class="col-md-12 mt-5 text-left">
                  -------------------
                </div>
              </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
      printData: {
      },
      data: {
        data: {},
        searching:{
            id: '',
            name: '',
            stage_id: '',
            group_id: '',
            parent_mobile: '',
            interview_date_from: '',
            interview_date_to: '',
            status: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       stages: [],
       groups: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
      this.flashAlert();
      this.search(null, '', this, 'stage');
      this.search(null, '', this, 'group');
      this.getIndexData(1);
  },
  methods: {
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    printTable(){
      setTimeout(() => {
      this.print_element('print-table', 'المقابلات الشخصية');
      
        
      }, 1000);
    },
    print(data){
      this.printData = data;
      setTimeout(() => {
      this.print_element('printMe', 'المقابلة الشخصية');

      }, 3000);
    },
    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stage');
      }
    },
    onSearchGroup(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'group');
      }
    },
    search(loading, w, vm, type){
      this.$baseApi.get('/interviews?pluck=1&search='+w+'&pluckType='+type).then((response)=>{
            if(loading){
            loading(false);
            }
            if(response.data.code == 200){
              if(type == 'stage'){
                this.stages = response.data.data.options;
              }
              if(type == 'group'){
                this.groups = response.data.data.options;
              }
            }else{
                alert(response.data.error.error);
            }
        });
    },

    getGroups(val){
      this.$baseApi.get('/interviews?pluck=1&i='+val.id+'&pluckType=group').then((response)=>{
            
            if(response.data.code == 200){
              
              this.groups = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
      getIndexData(page){
        this.$baseApi.get('/interviews?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data.interviews;
               this.data.data = response.data.data.interviews.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    },
    group(newValue) {
      this.data.searching.group_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
